<template>
  <footer class="HomeFooter-container">
    <div class="gb-wrap">
      <el-row class="my-foot-list">
        <!-- <el-col :span="16">
          <el-row>
            <el-col :span="12" class="my-foot-item">
              <i class="fa fa-phone" aria-hidden="true"></i>
              17360176579
            </el-col>
            <el-col :span="12" class="my-foot-item">
              <i class="fa fa-envelope-o" aria-hidden="true"></i>
              mxyd@66rpg.com
            </el-col>
            <el-col :span="24" class="my-foot-item">
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              成都高新区天府二街138号1栋15层1504号
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8" class="links">
          <span class="label">
            友情链接
          </span>
          <a href="http://www.muccylogic.com/" title="Muccy Games - 木夕工作室" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/muccygames-logo.png" alt="muccygames" />
          </a>
        </el-col> -->
      </el-row>
      <div class="my-foot-infowrap">
        <p class="mx-foot-info">
          <a class="mx-foot-link" href="http://beian.miit.gov.cn/" target="_blank"
            >蜀ICP备18037856号-1</a
          >
        </p>
        <!-- 新出发蓉零字第GX-C062号  -->
        <p class="mx-foot-info">
          <a class="mx-foot-link" href="https://mxcdn.muccyapi.com/muccybook/upload/202305/6f7f2f3ec79fbd684b678ab2dd7514bc.pdf" target="_blank"
            >新出发蓉零字第GX-C062号</a
          >
        </p>
        <!-- 营业执照  -->
        <p class="mx-foot-info">
          <a class="mx-foot-link" href="https://mxcdn.muccyapi.com/muccybook/upload/202305/263b468b47c6374c0fc28c12767d621a.png" target="_blank"
            >营业执照</a
          >
        </p>
        <!-- <p class="mx-foot-info">
          <span>成都轻橙时代网络科技有限公司</span>
          <i class="mx-foot-split">|</i>
          <span>地址：成都高新区天府二街138号1栋15层1504号</span>
        </p> -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'HomeFooter'
}
</script>

<style lang="less" scoped>
.HomeFooter-container {
  overflow: hidden;
  background: #1b2131;
}

.my-foot-list {
  margin-top: 30px;
  line-height: 60px;
  font-size: 25px;
  color: rgba(232, 230, 227, 0.7);
}

.my-foot-item {
  color: rgba(255, 255, 255, 0.7);
  &:first-child {
    margin-left: 0;
  }
  i {
    margin-right: 10px;
  }
}

.my-foot-infowrap {
  text-align: center;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  width: 500px;
  margin: 0 auto;
}

.mx-foot-info {
  margin: 10px auto;
  font-size: 12px;
  color: #ddd;
}

.mx-foot-link {
  color: inherit;
  &:hover {
    opacity: 0.5;
  }
}

.mx-foot-split {
  margin: 0 1em;
  opacity: 0.7;
  font-style: normal;
}
.links{
  display: flex;
  align-items: center;
  .label{
    margin-right: 20px;
    font-size: 18px;
  }
  a,img{
    width: 150px;
    height: 60px;
  }
}
</style>
